(function () {

  function initReviewSliders(context = document) {
    const sliders = context.querySelectorAll('.review-slider');

    sliders.forEach(slider => {

      
      if (typeof jQuery === 'undefined') return;
      if (typeof jQuery(slider).slick === 'undefined') return;
      if (jQuery(slider).hasClass('slick-initialized')) return;

      jQuery(slider).on('init', function () {
        slider.classList.add('slick-loaded');
      });

      jQuery(slider).slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        adaptiveHeight: true,
        prevArrow: `<button class="bttn bttn-prev"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5 15.5L1.5 8.50003L9.5 1.50003" stroke="#9A9A9A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg></button>
        `,
        nextArrow: `<button class="bttn bttn-next"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 1.50003L9.5 8.50003L1.5 15.5" stroke="#9A9A9A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg></button>
        `,
        responsive: [
          { 
            breakpoint: 1200, 
            settings: 
            { 
              slidesToShow: 3 
            }
          },
          { 
            breakpoint: 768,  
            settings: { 
              slidesToShow: 2
             }
          },
          { 
            breakpoint: 471,  
            settings: { 
              slidesToShow: 2 
            }}
        ]
      });

      
      slider.querySelectorAll('video').forEach(video => {
        if (!video) return;
        try {
          video.pause();
          video.currentTime = 0;
          video.controls = false;
          video.muted = false;
        } catch (e) {}
      });

    });
  }

  
 document.addEventListener("click", function (e) {
  const playIcon = e.target.closest(".play-icon");
  if (!playIcon) return;

  const wrapper = playIcon.closest(".review-video-wrap");
  if (!wrapper) return;

  const currentVideo = wrapper.querySelector("video");
  if (!currentVideo) return;

  // ✅ Pause ALL videos on page
  document.querySelectorAll(".review-video-wrap video").forEach(video => {
    try {
      video.pause();
      video.currentTime = 0;
      video.controls = false;

      const icon = video.closest(".review-video-wrap")?.querySelector(".play-icon");
      if (icon) icon.style.display = "flex";
    } catch (e) {}
  });

  // ✅ Play ONLY clicked video
  playIcon.style.display = "none";
  currentVideo.controls = true;
  currentVideo.play();
  currentVideo.onended = function () {
  try {
    currentVideo.controls = false;
    currentVideo.currentTime = 0;

    const icon = currentVideo
      .closest(".review-video-wrap")
      ?.querySelector(".play-icon");

    if (icon) icon.style.display = "flex";
  } catch (e) {}
};

});


  // ✅ Normal Load
  document.addEventListener('DOMContentLoaded', function () {
    initReviewSliders();
  });

  // ✅ Shopify Section Load
  document.addEventListener('shopify:section:load', function (event) {
    initReviewSliders(event.target);
  });

  // ✅ Shopify Block Select
  document.addEventListener('shopify:block:select', function (event) {
    initReviewSliders(event.target);
  });

  // ✅ Shopify Section Unload
  document.addEventListener('shopify:section:unload', function (event) {
    const sliders = event.target.querySelectorAll('.review-slider.slick-initialized');
    sliders.forEach(slider => {
      try {
        jQuery(slider).slick('unslick');
      } catch (e) {}
    });
  });

})();
